import { useEndpointFetch } from '../../../../../global/network/useEndpointFetch';

interface ProgressStageRequest {
  applicationId: string;
  newStageId: string;
  isManualApproval?: boolean;
}

interface ProgressStageResponse {
  success: boolean;
  message?: string;
}

const useProgressApplicationStage = () => {
  const progressStage = useEndpointFetch<ProgressStageRequest, ProgressStageResponse>(
    '/vm/application/progress-stage'
  );

  const progressToStage = async (applicationId: string, newStageId: string): Promise<boolean> => {
    try {
      const response = await progressStage.run({
        applicationId,
        newStageId,
        isManualApproval: true, // Always manual for admin/PM progression
      });

      return response.ok;
    } catch (error) {
      console.error('Failed to progress application stage:', error);
      return false;
    }
  };

  return {
    progressToStage,
    isLoading: progressStage.isLoading,
    error: progressStage.error,
  };
};

export { useProgressApplicationStage };